export default __webpack_public_path__ + "static/media/launchpad.6c3e3a99.svg";